const contextSelectors = function() {
  const self = {};

  // selects user context out of the root state shape
  // state.user.context
  const _select = function(state) {
    return state.user.context;
  };

  // select current users context user
  // eventually will be used for user switch context
  self.selectUserId = function(state) {
    const root = _select(state);

    return root.userId;
  };

  // select current users client context
  self.selectClientId = function(state) {
    const root = _select(state);

    return root.clientId;
  };

  // TODO: this seems like a hack and probably should be just taken from a session
  self.selectUserClientId = function(state) {
    const root = _select(state);

    return root.userClientId;
  };

  // select if a user is in switch context mode
  self.selectInSwitchContext = function(state) {
    const root = _select(state);

    return root.inSwitchContext;
  };

  return self;
};

export default contextSelectors();
